'use client'

import { useEffect } from 'react'
import { trackVacancyView } from '@/utilities/analytics'

interface VacancyViewTrackerProps {
  title: string
  slug: string
}

/**
 * Client component to track vacancy page views
 * Place this in vacancy detail pages
 */
export function VacancyViewTracker({ title, slug }: VacancyViewTrackerProps) {
  useEffect(() => {
    trackVacancyView(title, slug)
  }, [title, slug])

  return null
}

